<div class="rep-list">
  <mat-form-field appearance="outline" class="component-width">
    <onsip-selection-list-deluxe disableRipple color="primary" [formControl]="formControl">
      @for (rep of allReps | async; track rep.userId) {
      <mat-list-option [value]="rep.userId" checkboxPosition="before">
        {{ rep.contactName }}
        <onsip-avatar
          matListItemAvatar
          [name]="rep.contactName"
          [avatarUrl]="rep.userAvatarUrl"
        ></onsip-avatar>
      </mat-list-option>
      }
    </onsip-selection-list-deluxe>
  </mat-form-field>
</div>
